import { Grid, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  message: {
    padding: theme.spacing(1),
    width: "fit-content",
    maxWidth: "85%",
    border: "0.1px solid #979797",
    marginBottom: theme.spacing(1),
    backdropFilter: "blur(0px)",
    filter: "drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.25))",
  },
  userMessage: {
    backgroundColor: "#DAF3D8",
    alignSelf: "flex-end",
    borderRadius: "10px 0px 10px 10px",
  },
  contactMessage: {
    backgroundColor: "#FFFFFF",
    alignSelf: "flex-start",
    borderRadius: "0px 10px 10px 10px",
  },
}));

const MessageContainer = ({
  text,
  botMessage,
  dashboards,
  handleLocationChange,
  isAnswered,
  dashboardChartMapping,
  dashbaordIdNavItemMap,
}) => {
  const elements = useSelector(state => state.app.user.elements);
  const classes = useStyles();

  function getDashboardIds(data) {
    const dashboardIds = new Set();

    data.forEach(navItem => {
      if (navItem.charts) {
        navItem.charts.forEach(chart => {
          console.log(chart, 'AIWINDOW_DEBUG')
          if (chart.dashboard_id) {
            dashboardIds.add(chart.dashboard_id);
          }
        });
      }
    });

    return dashboardIds;
  }

  const dashboardIdsSet = getDashboardIds(elements);

  // Get intersection of recommended dashboards and available dashboard IDs
  const filteredDashboards = dashboards ? dashboards.filter(dashboardId => dashboardIdsSet.has(dashboardId)) : [];

  console.log('Filtered Dashboards:', filteredDashboards, dashboardIdsSet, dashboards, 'AIWINDOW_DEBUG');

  return (
    <Grid
      container
      className={`${classes.message} ${botMessage ? classes.contactMessage : classes.userMessage}`}
    >
      <Grid item>
        <Typography style={{ fontWeight: 400 }} variant="body1">
          {text}
          {botMessage && filteredDashboards && filteredDashboards.length > 0 && (
            <>
              {`The following dashboard${filteredDashboards.length > 1 ? "s" : ""} can provide you more information:`}{" "}
              {filteredDashboards.map((it) => (
                <span
                  key={it}
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "blue",
                  }}
                  onClick={() =>
                    handleLocationChange(
                      dashboardChartMapping[it],
                      dashbaordIdNavItemMap[it]
                    )
                  }
                >
                  {"\n"}
                  {dashboardChartMapping[it]}
                </span>
              ))}
            </>
          )}
          {botMessage && filteredDashboards && filteredDashboards.length === 0 && "You don't have access to any of the recommended dashboards."}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default MessageContainer;
